import { useRef, useMemo } from 'react';

import getItemIdentifier from '../utils/getItemIdentifier';

const useExpandedRegistery = (initialValues = []) => {
  const values = useRef(initialValues);

  return useMemo(() => {
    // check if item with provided properties is expanded
    const isItemExpanded = (id, type) => {
      const identifier = getItemIdentifier(id, type);

      return values.current.includes(identifier);
    };

    // change expanded state of the item with provided proprties.
    const toggle = (id, type, isExpanded) => {
      const identifier = getItemIdentifier(id, type);

      if (isExpanded) {
        values.current = [...values.current, identifier];
      } else {
        values.current = values.current.filter((i) => i !== identifier);
      }
    };

    // will reset registery to initial values.
    const resetAll = () => {
      values.current = initialValues;
    };

    return { toggle, isItemExpanded, resetAll };
  }, [initialValues]);
};

export default useExpandedRegistery;
